import React from 'react'
import _ from 'lodash'
import Moment from 'moment';
import { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import {
  Button,
  Input, Label,
  ModalBody, ModalFooter, ModalHeader,
  Form, FormGroup, FormText, FormFeedback
} from 'reactstrap';

import Lang from 'Lang/General';
import ImageField from 'components/ImageField/index'
import DatePicker from 'react-datepicker';

function FairForm({
  data,
  mode,
  countries,
  onSubmit,
  onClose,
  clientID,
  selectedFairs,
  fairErrorMessage
}) {
  const [ selectedCountry, setSelectedCountry ] = useState( null )
  const [formData, setFormData] = useState( DEFAULT_FAIR )

  useEffect( () => {
    setSelectedCountry( null )
  }, [] )

  useEffect(() => {
    if ( mode === 'edit' && !_.isEmpty( selectedFairs ) ) {
      setFormData({
        ...selectedFairs,
        start_date: new Date( selectedFairs.start_date ),
        end_date: new Date( selectedFairs.end_date ),
        status: selectedFairs.is_active ? 'ACTIVE' : "INACTIVE"
      })
    }
  }, [selectedFairs])

  useEffect( () => {
    if (
      !selectedCountry &&
      !_.isEmpty( selectedFairs ) &&
      countries.length > 0
    ) {
      setSelectedCountry( _.find( countries, { value: selectedFairs.country } ) )
    }
  }, [ selectedFairs, countries, selectedCountry ] )

  const onChangeField = (key, val) => setFormData({
    ...formData,
    [key]: val
  })

  return (
    <>
      <ModalHeader toggle={() => onClose()} >
        {Lang[mode === 'create' ? 'CREATE_FAIR' : 'UPDATE_FAIR'][data.languageReducer.userSettings.admin_panel_language]}</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label>
              {Lang['TITLE'][data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <Input
              value={formData.title}
              invalid={fairErrorMessage.title}
              onChange={e => onChangeField('title', e.target.value)}
            />
            <FormFeedback>{ fairErrorMessage.title }</FormFeedback>
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['SHORT'][data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <Input
              value={formData.short_title}
              invalid={fairErrorMessage.short_title}
              onChange={e => onChangeField('short_title', e.target.value)}
            />
            <FormFeedback>{ fairErrorMessage.short_title }</FormFeedback>
          </FormGroup>
          {
            mode === 'edit' && (
              <FormGroup>
                <Label>
                  {Lang['SLUG'][data.languageReducer.userSettings.admin_panel_language]}
                </Label>
                <Input
                  value={formData.slugs}
                  invalid={fairErrorMessage.slugs}
                  onChange={e => onChangeField('slugs', e.target.value)}
                />
                <FormFeedback>{ fairErrorMessage.slugs }</FormFeedback>
              </FormGroup>
            )
          }
          <FormGroup>
            <Label>
              {Lang['CITY'][data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <Input
              value={formData.city}

              onChange={e => onChangeField('city', e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['COUNTRY'][data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <ReactSelect
              options={countries}
              value={ selectedCountry }
              onChange={ v => setSelectedCountry( v ) }
              placeholder={Lang['SELECT_COUNTRY'][data.languageReducer.userSettings.admin_panel_language]} 
              styles={{
                control: baseStyles => !fairErrorMessage.country
                  ? baseStyles
                  : ({ ...baseStyles, zIndex: 800, borderColor: 'red' })
              }}
            />
            <FormText color="danger">{fairErrorMessage.country || ''}</FormText>
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['START'][data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <DatePicker
              locale={data.languageReducer.userSettings.admin_panel_language}
              className="form-control"
              popperPlacement='bottom-start'
              popperModifiers={{
                flip: { behavior: ['bottom'] },
                preventOverflow: { enabled: false },
                hide: { enabled: false }
              }}
              dateFormat='yyyy/MM/dd'
              selected={formData.start_date}
              onChange={ date => onChangeField( 'start_date', date || new Date() )}
            />
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['END'][data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <DatePicker
              locale={data.languageReducer.userSettings.admin_panel_language}
              className="form-control"
              popperPlacement='bottom-start'
              popperModifiers={{
                flip: { behavior: ['bottom'] },
                preventOverflow: { enabled: false },
                hide: { enabled: false }
              }}
              dateFormat='yyyy/MM/dd'
              selected={formData.end_date}
              onChange={ date => onChangeField( 'end_date', date || new Date() )}
            />
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['HALL'][data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <Input
              value={formData.hall}
              onChange={e => onChangeField('hall', e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['LOCATIONS'][data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <Input
              value={formData.location}
              onChange={e => onChangeField('location', e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['TICKET_SHOP_URL'][data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <Input
              value={formData.ticket_shop_url}
              onChange={e => onChangeField('ticket_shop_url', e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['NOTICE'][data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <Input
              value={formData.notice}
              type={'textarea'}
              onChange={e => onChangeField('notice', e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['STATUS'][data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <Input
              value={formData.status}
              type={'select'}
              onChange={e => onChangeField('status', e.target.value)}
            >
              <option value="ACTIVE">
                {Lang['ACTIVE'][data.languageReducer.userSettings.admin_panel_language]}
              </option>
              <option value="INACTIVE">
                {Lang['INACTIVE'][data.languageReducer.userSettings.admin_panel_language]}
              </option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['COVER_PHOTO'][data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <ImageField
              fileName={formData.cover_photo?.filename??''}
              fileValue={formData.cover_photo?.url??''}
              onChange={val => setFormData({
                ... formData,
                cover_photo: {
                  ... formData.cover_photo,
                  ... val
                }
              })}
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color='primary'
          onClick={() => {
            let temp = _.cloneDeep(formData)
            temp.country = selectedCountry?.value
            temp.client_id = clientID
            temp.start_date = Moment(temp.start_date).startOf( 'day' ).utcOffset( '+0000', true ).utc().format()
            temp.end_date = Moment(temp.end_date).startOf( 'day' ).utcOffset( '+0000', true ).utc().format()
            temp.cover_photo = selectedFairs && formData.cover_photo.url === selectedFairs.cover_photo.url ? null : {
              raw: formData.cover_photo.raw,
              filename: formData.cover_photo.filename
            }
            onSubmit({
              ...temp,
              is_active: formData.status === 'ACTIVE'
            })
          }}>
          {Lang['SUBMIT'][data.languageReducer.userSettings.admin_panel_language]}</Button>
      </ModalFooter>
    </>
  )
}

const DEFAULT_FAIR = {
  title: '',
  notice: '',
  ticket_shop_url: '',
  short_title: '',
  slugs: '',
  start_date: new Date(),
  end_date: Moment().add( 1, 'month' ).toDate(),
  country: '',
  city: '',
  status: 'ACTIVE',
  hall: '',
  location: '',
  client_id: 0,
  cover_photo: {
    url: '',
    raw: '',
    filename: ''
  }
}

export default FairForm